import i18n from 'i18next';
import { Modal } from 'antd';

import { useChunkedUploadQueue } from '@hooks/operator/useChunkedUploadQueue';

/**
 * 退貨驗收影片 chunked 上傳佇列 — `useChunkedUploadQueue` 的薄包裝，把端點 URL
 * 和 overflow / finalize 失敗的 Modal 提示固定下來。和 QC 那組 (`QcContext` 內聯
 * 設定) 同源不同 entity，所以另外提供一個 hook 避免兩邊 caller 各自重複設定。
 */
export function useReturnReceiptChunkedUploadQueue() {
  return useChunkedUploadQueue({
    signEndpoint: (entityId) =>
      `return_receipts/${entityId}/recording_chunks/sign`,
    finalizeEndpoint: (entityId, sessionId) =>
      `return_receipts/${entityId}/recording_sessions/${sessionId}/finalize`,
    onQueueOverflow: () => {
      Modal.error({
        title: i18n.t('operator.return_verification.video.queue_overflow_title', {
          defaultValue: '影片上傳暫停',
        }),
        content: i18n.t('operator.return_verification.video.queue_overflow_content', {
          defaultValue:
            '網路狀況不穩 — 上傳佇列已滿。請聯絡 IT 並暫停錄影到問題排除。',
        }),
      });
    },
    onFinalizeFailed: ({ sessionId, missing }) => {
      console.error('[ReturnVerification] Finalize failed', { sessionId, missing });
      Modal.error({
        title: i18n.t('operator.return_verification.video.finalize_failed_title', {
          defaultValue: '影片上傳失敗',
        }),
        content: i18n.t('operator.return_verification.video.finalize_failed_content', {
          count: missing.length,
          defaultValue: `有 ${missing.length} 段影片遺失 — 這支影片不完整。請重置並重新錄影驗收。`,
        }),
      });
    },
  });
}
